var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "py-4" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("main", [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "vstack gap-4 text-center" }, [
          _c("img", {
            attrs: { src: _vm.maintenance, width: "auto", height: "300px" },
          }),
          _vm._v(" "),
          _c("h1", { staticClass: "h2 ls-tight" }, [
            _vm._v("Modo mantenimiento!!!"),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("Esta sección está en construcción. ¡Vuelva más tarde!"),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "pb-4" }, [
          _c("div", { staticClass: "row align-items-end" }, [
            _c("div", { staticClass: "col-sm col-12" }),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }